import {
  DepositCondition,
  FormConditionCondition,
} from '@urbanx/agx.campaigns.client'
import { DropdownOption } from '@urbanx/agx.ui-components2'

const baseOption: DropdownOption = { label: '-', value: '' }

const financeOptions: DropdownOption[] = [
  {
    label: 'finance being satisfied',
    value: FormConditionCondition.FinanceBeingSatisfied,
  },
  {
    label: 'building and pest being satisfied',
    value: FormConditionCondition.BuildingAndPestBeingSatisfied,
  },
  {
    label: 'satisfaction of special condition',
    value: FormConditionCondition.UponSatisfactionOfSpecialCondition,
  },
]

export const ConditionFromOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Contract date',
    value: FormConditionCondition.NdaysFromDate,
  },
  {
    label: 'specific date',
    value: FormConditionCondition.OnSpecificDate,
  },
  ...financeOptions,
]

// For "On..." segment in Initial deposits - uses OnDate for contract date
export const InitialDepositOnDateOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Contract date',
    value: DepositCondition.OnDate,
  },
  {
    label: 'specific date',
    value: FormConditionCondition.OnSpecificDate,
  },
  ...financeOptions,
]

// For "On..." segment in Balance deposits - uses OnDate for unconditional date
export const BalanceDepositOnDateOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Unconditional date',
    value: DepositCondition.OnDate,
  },
  {
    label: 'specific date',
    value: FormConditionCondition.OnSpecificDate,
  },
  ...financeOptions,
]

// For "# days from..." segment in Initial deposits
export const InitialDepositNDaysOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Contract date',
    value: FormConditionCondition.NdaysFromDate,
  },
  ...financeOptions,
]

// For "# days from..." segment in Balance deposits
export const BalanceDepositNDaysOptions: DropdownOption[] = [
  baseOption,
  {
    label: 'Unconditional date',
    value: FormConditionCondition.NdaysFromDate,
  },
  ...financeOptions,
]
